import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgChatBubbleDots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="m10 15-4 4v-4H2a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM5 7v2h2V7zm4 0v2h2V7zm4 0v2h2V7z"
      fill="currentColor"
    />
  </svg>
);
